export * from './useCompactPaymentsSecondaryMenu.types';
export { default as useCompactPaymentsSecondaryMenu } from './useCompactPaymentsSecondaryMenu';
